import {
    SELECT_MARKETING_AUTOMATION
} from '../../actions/types';

const INITIAL_STATE = {
    redirected: false,
    trigger: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SELECT_MARKETING_AUTOMATION:
            return { redirected: true, trigger: action.payload };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/marketingAutomations/SelectedMarketingAutomationReducer.js